import React from 'react'
import styled from '@emotion/styled'
import { ModalFooter, ModalWindow, ModalContent } from 'view/components/panels'
import { DialogField, DialogRow } from 'view/components/inputs'
import { TextButton, TextButtonType } from 'view/components/buttons'
import * as constants from 'view/styles/constants'
import { Locale, Translation } from 'locale'

interface UnhappyModalProps {
  title: string
  message?: string
  onClose?: () => unknown
}

const UnhappyContent = styled(ModalContent)<{}>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 0;
  margin: 0 24px;
  width: 1200px;
  min-height: 500px;
  border-bottom: 1px solid ${constants.CORE_PRIMARY_1};
  color: ${constants.CORE_PRIMARY_6};
`

export const UnhappyModal: React.FunctionComponent<UnhappyModalProps> = ({ title, message, onClose }) => {
  return (
    <ModalWindow title={title}>
      <UnhappyContent>{message}</UnhappyContent>
      <ModalFooter>
        <DialogRow>
          <DialogField flex={0}>
            <TextButton type={TextButtonType.Primary} onClick={() => onClose && onClose()}>
              {Locale.translate(Translation.TC_BUTTON_CLOSE)}
            </TextButton>
          </DialogField>
        </DialogRow>
      </ModalFooter>
    </ModalWindow>
  )
}
